export default "__VITE_ASSET__BOE_$wy1__"